/* Menu v hlavicce se samo prizpusobi dostupne sirce, aby se neprekryvalo s logem */
(function () {
  function fit() {
    var root = document.getElementById('SiteHeader');
    var box = document.querySelector('#SiteHeader .header-item--navigation');
    var nav = box ? box.querySelector('.site-nav') : null;
    if (!root || !box || !nav) return;
    if (window.innerWidth < 769) {
      root.style.removeProperty('--tx-nav-fs');
      root.style.removeProperty('--tx-nav-pad');
      return;
    }
    var fs = window.innerWidth >= 1700 ? 16.5 : 16;
    var pad = window.innerWidth >= 1700 ? 14 : 12;
    root.style.setProperty('--tx-nav-fs', fs + 'px');
    root.style.setProperty('--tx-nav-pad', pad + 'px');
    var guard = 0;
    while (nav.scrollWidth > box.clientWidth - 24 && guard < 60) {
      if (pad > 5) { pad -= 1; } else if (fs > 12) { fs -= 0.5; } else { break; }
      root.style.setProperty('--tx-nav-fs', fs + 'px');
      root.style.setProperty('--tx-nav-pad', pad + 'px');
      guard++;
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', fit); } else { fit(); }
  window.addEventListener('load', fit);
  if (document.fonts && document.fonts.ready) { document.fonts.ready.then(fit); }
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fit, 120); });
})();
